import { NAME } from './constants';

export const SET_PACKAGE = `${NAME}/SET_PACKAGE`;
export const SET_PACKAGE_LIST = `${NAME}/SET_PACKAGE_LIST`;
export const SET_PACKAGE_LIST_IS_LOADING = `${NAME}/SET_PACKAGE_LIST_IS_LOADING`;
export const SET_FILTER = `${NAME}/SET_FILTER`;
export const SELECT_PACKAGE = `${NAME}/SELECT_PACKAGE`;
export const UNSELECT_ALL_PACKAGES = `${NAME}/UNSELECT_ALL_PACKAGES`;
